import React from 'react';
import styled from 'styled-components';
import {
  ButtonIcon,
  ButtonCondensed,
  Menu,
  MenuItem,
} from '@companycam/slab-web';
import { translate } from 'translations/i18n';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { LD_DOCUMENTS_DOCUMENT_BUILDER } from 'constants/featureFlags';

import {
  getExamplePages,
  ExamplePageId,
  examplePagesKeys,
} from '../examples/examplePages';
import ReadOnlyTipTap from './ReadOnlyTipTap';
import InvoiceFeedbackBanner from '../examples/InvoiceFeedbackBanner';

const PageHeader = styled.div`
  position: sticky;
  top: 0;
  padding: var(--cc_size_spacing_s) var(--cc_size_spacing_m);
  background-color: white;
  border-bottom-width: var(--cc_size_border_width_s);
  border-bottom-style: solid;
  border-bottom-color: var(--cc_color_border_default);
  z-index: 200;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

type ExamplePagePreviewProps = {
  pageTemplateId: ExamplePageId;
  onCreateFromTemplate: (pageTemplateId: ExamplePageId) => void;
  onClose: () => void;
};

const ExamplePagePreview = ({
  pageTemplateId,
  onCreateFromTemplate,
  onClose,
}: ExamplePagePreviewProps) => {
  // Invoice Page Beta uses Document Builder flag to serve to same beta group
  const { [LD_DOCUMENTS_DOCUMENT_BUILDER]: isBetaFlagEnabled } = useFlags();

  const examplePage = getExamplePages({
    id: pageTemplateId,
    includePagesBetaFeatures: isBetaFlagEnabled,
  });

  const examplePageContent = {
    title: examplePage?.title,
    tiptapContent: examplePage?.body,
  };
  return (
    <>
      <PageHeader>
        <ButtonCondensed
          icon={{
            name: 'chevron-left',
            position: 'before',
          }}
          onClick={onClose}
        >
          {translate('common.back')}
        </ButtonCondensed>
        <Menu
          triggerButton={
            <ButtonIcon
              accessibilityLabel="Dropdown arrow"
              iconName="dots-horizontal"
              size="small"
            />
          }
        >
          <MenuItem
            iconName="file-document-plus-outline"
            onClick={() => onCreateFromTemplate(pageTemplateId)}
          >
            {translate('pageTemplates.preview.createFromTemplate')}
          </MenuItem>
        </Menu>
      </PageHeader>

      {pageTemplateId === examplePagesKeys.invoice ? (
        <InvoiceFeedbackBanner />
      ) : null}

      <ReadOnlyTipTap pageTemplate={examplePageContent} />
    </>
  );
};

export default ExamplePagePreview;
